import {APIInterface} from '../APIInterface'

class RESTController extends APIInterface {
    constructor() {
        super();

        let dev = process.env.NODE_ENV === 'development';

        const apiURLOnline = "https://admin.wentylatory.netecs.pl/api/Went/";
        const apiURLOnlineDev = "https://admin.dev.nvselection.com/api/Went/";
        //do lokalnego uruchomienia projektu:
        //const apiURLOnlineDev = "https://admin.dev.nvselection.com/api/Went/";
        const apiURLOffline = "https://localhost/api/Went/";

        this.offlineMode = false;

        if(this.offlineMode) {
            this.apiURL = apiURLOffline;
        } else {
            if(dev) {
                this.apiURL = apiURLOnlineDev;
            } else {
                this.apiURL = apiURLOnline;
            }
        }

        this.authorization = this._getSavedAuthorization();
    }

    async getFanTypeList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiApp/getFanTypeList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async loginUser(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiClient/postLogin", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async registerUser(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiClient/postRegister", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async verifyUser(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiClient/postVerifyUser", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async checkUserToken(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiClient/postCheckUserToken", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    getAppPathsList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiApp/getAppPathsList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    getMaterialSortList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiApp/getMaterialSortList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    getAppPathsFanTypesList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiApp/getAppPathsFanTypesList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    getAppPathsParametersSettingsList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiApp/getAppPathsParametersSettingsList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    getAppTableParametersSettingsList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiApp/getAppTableParametersSettingsList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    getAppPathsWorkPointsSettingsList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiApp/getAppPathsWorkPointsSettingsList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    getAppFansImagesList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiApp/getAppFansImagesList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    fileUploadDropzoneUrl() {
        return this._getURL('ApiFile/postFile');
    }

    async getFanSortList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiApp/getFanSortList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getLanguagesList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiTranslator/getLanguagesList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getTranslationsList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiTranslator/getTranslationsList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getTemperatureRangesWithManufacturers() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiEngine/getTemperatureRangesWithManufacturers").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getEfficiencyRangesWithIeClass() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiEngine/getEfficiencyRangesWithIeClass").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getUnitsList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiUnit/getUnitsList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getUnitTypesList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiUnit/getUnitTypesList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getMeasurementsList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiMeasurement/getMeasurementsList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getFanCharacteristicsList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiFan/getFanCharacteristicsList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getFansTypesList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiFan/getFansTypesList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getConnectionsList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiConnection/getConnectionsList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getEngineStartupList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiEngineStartup/getEngineStartupList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getOctaveNoiseList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiOctaveNoise/getOctaveNoiseList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    getFansOfPath(id_app_fan_type, id_app_fan_sort) {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiFan/getFansOfPath/" + id_app_fan_type + "/" + id_app_fan_sort).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getDefaultManufacturer() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiEngine/getDefaultManufacturer").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getEnginesList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiEngine/getEnginesList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getPricesList(userToken) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiPrice/getPricesList", userToken).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getCurrenciesList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiPrice/getCurrenciesRates").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getOfferSurchargesOptions() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiOffers/getOfferSurchargesOptions").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    // NVS-95
    async getOfferDiscountsOptions() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiOffers/getOfferDiscountsOptions").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    // NVS-152
    async getOfferAntiCorrosionOptions() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiOffers/getOfferAntiCorrosionOptions").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async sendMaterialRequest(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiRequest/sendMaterialRequest", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getSinglePdf(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiPdf/getSinglePdf", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getFanRender(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiFan/getFanRender", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getFansAtexesList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiFan/getFansAtexesList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getRelationsFanAtexes() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiFan/getRelationsFanAtexes").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getFansVersionsList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiFan/getFansVersionsList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getFansAtexTypes() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiFan/getFanAtexTypes").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getFansExtrasList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiFan/getFansExtrasList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getRelationsFanVersionsExtrasList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiFan/getRelationsFanVersionsExtrasList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getFansPositionsList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiFan/getFansPositionsList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getRelationsFanTypesPositionsList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiFan/getRelationsFanTypesPositionsList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    // NVS-91
    async getSettingsFullList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiAppSettings/getSettingsFullList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getVariablesFullList() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiAppVariables/getVariablesFullList").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getFanByTypeNumber(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiFan/getFanByTypeNumber", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getFanByTypeNumberHandshake(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiFan/getFanByTypeNumberHandshake", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async sendOffer(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiOffers/sendOffer", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async logChoiceTime(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiEvents/logChoiceTime", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async approveOffer(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiOffers/approveOffer", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async cancelOffer(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiOffers/cancelOffer", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getOffersOfUser() {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiOffers/getOffersOfUser").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getOfferOfId(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiOffers/getOfferOfId", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getOfferOfServerId(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiOffers/getOfferOfServerId", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async postResetPassword(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiClient/postResetPassword", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async removeFileFromServer(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiFile/removeAttachment", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async postRequestPasswordReset(data) {
        return new Promise(function (resolve, reject) {
            try {
                this._POST("ApiClient/postRequestPasswordReset", data).then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    async getLastEvent() {
        return new Promise(function (resolve, reject) {
            try {
                this._GET("ApiEvents/getLastEvent").then(function (response) {
                    resolve(response);
                }.bind(this));
            } catch (e) {
                reject(e);
            }
        }.bind(this));
    }

    _getSavedAuthorization() {
        return localStorage.userApplicationToken;
    }

    _saveAuthorization() {

    }

    async _GET(endpoint) {
        const response = await fetch(this._getURL(endpoint), {
            method: 'GET',
            headers: {
                'Authorization' : this._getSavedAuthorization(),
            },
            cache: "no-cache"
        });
        const myJson = await response.json(); //extract JSON from the http response

        return myJson;
    }

    async _POST(endpoint, data) {
        const response = await fetch(this._getURL(endpoint), {
            method: 'POST',
            body: data,
            headers: {
                'Authorization' : this._getSavedAuthorization(),
            },
            cache: "no-cache"
        });
        const myJson = await response.json(); //extract JSON from the http response

        return myJson;
    }

    manageReturnedData(returnedData, defaultData) {
        if (returnedData && returnedData['status'] && returnedData['status'] == "success" && returnedData['data'])
            return returnedData['data'];
        else
            return defaultData
    }

    _getURL(endpoint) {
        if (this.apiURL.endsWith("/"))
            this.apiURL = this.apiURL.slice(0, -1) + '';
        if (!endpoint.startsWith("/"))
            endpoint = "/" + endpoint;

        return this.apiURL + endpoint
    }

}

export {RESTController};
